




































import _ from 'lodash'
import { State, Getter, Action } from 'vuex-class'
import { Component, Prop, Vue } from 'vue-property-decorator'
import Draggable from 'vuedraggable'
import { RootState } from '@/store/types'
import { StencilSet } from '@/store/editor/types'
import { Maybe } from '@/types/general'
import Entry from '@/data/entry-model'
import { SET_SORT_ORDER } from '@/store/entries/constants'
import { SortOrderUpdate } from '@/store/entries/actions'

import VaultListItem from './VaultListItem.vue'
import VaultListRoot from './VaultListRoot.vue'

interface DragEvent extends Event {
    newIndex: number
    oldIndex: number
}

@Component({
    components: { VaultList, VaultListItem, VaultListRoot, Draggable },
    name: 'vault-list'
    })
export default class VaultList extends Vue {
    @State((state: RootState) => state.ui.searchTerm)
    searchTerm!: string

    /**
     * Depth of directory
     *
     * Corresponds to the index in the vault tree of the current
     * directory
     */
    @Prop({ type: Number, default: 0 })
    depth!: number

    /**
     * Stack of open vaults in the vault tree
     */
    @Getter
    openVaults!: Entry[]

    /**
     * Stack of open vaults in the vault tree
     */
    @Getter
    searchResults!: Entry[]

    @Getter
    searching!: boolean

    @Getter
    topLevelEntries!: Entry[]

    @Getter
    getEntries!: (entryIds: string[]) => Entry[]

    /**
     * Update the sort order for an entry
     */
    @Action(SET_SORT_ORDER)
    setSortOrder!: ({ entry, newIndex }: SortOrderUpdate) => Promise<void>

    /**
     * The currently open directory, or undefined if this is
     * the root directory
     */
    get parent(): Maybe<Entry> {
        return this.depth > 0
            ? this.openVaults[this.depth - 1]
            : undefined
    }

    /**
     * The child vault, which will be rendered with a new VaultList
     * as the parent
     */
    get vault(): Maybe<Entry> {
        return this.openVaults.length > this.depth
            ? this.openVaults[this.depth]
            : undefined
    }

    /**
     * List of all entries contained in the parent vault, or root vault,
     * ordered by the sortOrder attribute
     */
    get entries(): Entry[] {
        if (this.searchTerm !== '') {
            return this.searchResults
        }
        const entries = this.parent
            ? this.parent.children
            : this.topLevelEntries
        return _.sortBy(entries, 'sortOrder')
    }

    /**
     * Update the sort order of the entry when dragging ends
     */
    dragEnd({ newIndex, oldIndex }: DragEvent): void {
        this.setSortOrder({ entry: this.entries[oldIndex], newIndex })
    }
}
